<template>
  <div class="step__cards" :class="{'step__cards--mobile2':template === 'i'}">
    <div v-for="(item, index) in items" :key="index" :class="{'s-card':template === 's', 'i-card':template === 'i', 'active':item['ID'] === selectedId}" @click="select(item)">
      <div :class="{'s-card__img':template === 's', 'i-card__img':template === 'i'}">
        <img :src="item.PICTURE ? item.PICTURE.src : ''" alt="Изображение" loading="lazy">
        <div v-if="item.DESCRIPTION" :class="{'s-card__img-description':template === 's', 'i-card__img-description':template === 'i'}" v-html="item.DESCRIPTION"></div>
      </div>
      <div :class="{'s-card__title':template === 's', 'i-card__title':template === 'i'}">{{ item.NAME }}</div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  name  : "DefaultStep",
  props : ["number", "items", "parent", "template"],
  data()
  {
    return {
      selected : null
    };
  },
  methods  : {
    ...mapActions([
      "GET_STEPS", "SET_PARENT", "SET_SELECT", "SET_DOOR", "SET_PANEL"
    ]),
    select( item )
    {
      if(this.moduleConfigurator.steps[this.number - 1].SELECTED.id === item.ID)
      {
        return;
      }
      this.selected = item;
      this.SET_SELECT({
        index : parseInt(this.number) - 1,
        name  : this.selected["NAME"],
        id    : this.selected["ID"]
      });
      this.SET_PARENT({
        id             : item.ID,
        parent_section : this.parent
      });
      this.GET_STEPS();
      if(item.UF_CHANGE_DOOR === "0")
      {
        this.SET_DOOR(0);
      }
      if(item.UF_CHANGE_PANEL === "0")
      {
        this.SET_PANEL(0);
      }
    },
  },
  computed : {
    ...mapState([
      "moduleConfigurator"
    ]),
    selectedId()
    {
      return this.moduleConfigurator.steps[this.number - 1]["SELECTED"].id ?? false;
    }
  },
  created()
  {
    if(localStorage.firstStep)
    {
      let ind = this.items.findIndex(item =>
      {
        return item.ID === localStorage.firstStep.toString();
      });
      if(ind !== -1)
      {
        this.select(this.items[ind]);
      }
      localStorage.removeItem("firstStep");
    }
    if(localStorage.secondStep)
    {
      let ind2 = this.items.findIndex(item =>
      {
        return item.ID === localStorage.secondStep.toString();
      });
      if(ind2 !== -1)
      {
        this.select(this.items[ind2]);
      }
      localStorage.removeItem("secondStep");
    }
  }
}
</script>

<style scoped>

</style>